import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/app/expert-advice/components/CTA_ChatCompact/CTA_ChatCompact.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/app/expert-advice/components/LearnMoreMenu/LearnMoreMenu.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/app/expert-advice/components/RecentPostsController/RecentPostsController.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/components/atoms/Button/Button.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/components/icons/IconArrowLeft/icon-arrow-left.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/components/articles/ArticleCard/article-card.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/components/atoms/Button/button.module.css");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3384751736/src/hvac-next/node_modules/react-wrap-balancer/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3384751736/src/hvac-next/public/img/expert-advice/learning-center-Furnaces.webp");
